import React from 'react';

import classes from "./SideBar.module.css";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch} from '@fortawesome/free-solid-svg-icons';
import SearchBar from "../SearchBar/SearchBar";
import Spinner from 'react-bootstrap/Spinner';
function SideBar(){
    return(
        <div className={classes.container}>
          
          
           
            <div className={classes.sidebarItems}>
               
                <a href="/" className={classes.links}><h4 className={classes.eachItem}>HOME</h4></a>
                <a href="/products/men" className={classes.links}><h4 className={classes.eachItem}>MEN</h4></a>
                <a href="/products/women" className={classes.links}><h4 className={classes.eachItem}>WOMEN</h4></a>
                
                
                

                
            </div>
           
            <div className={classes.sidebarSearch}>
           <SearchBar className={classes.SearchBar}/>
                
           </div>

        </div>
        
    )
}

export default SideBar;
